(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["associated-market-fees"] && !Shopify.designMode) return;
  try {
    (function () {
    function stripTags(value) {
      return (value || '').replace(/<[^>]*>/g, '').trim();
    }

    function decodeEntities(value) {
      if (!value) return '';
      var ta = document.createElement('textarea');
      ta.innerHTML = value;
      return ta.value;
    }

    function feeAmount(fee) {
      if (fee.price_type === 'percentage') {
        var pct = parseFloat(fee.price) / 100;
        if (isNaN(pct)) return '';
        return pct + '%';
      }
      return stripTags(decodeEntities(fee.information_price));
    }

    function feeApplies(fee, opts) {
      var logic = fee.logic;

      var channels = Array.isArray(logic.sales_channels) ? logic.sales_channels : [];
      if (channels.length && channels.indexOf('online_store') === -1) return false;

      var markets = Array.isArray(logic.markets) ? logic.markets.map(String) : [];
      if (markets.length === 0) {
        if (opts.onlyMarketScoped) return false;
      } else if (!opts.marketId || markets.indexOf(opts.marketId) === -1) {
        return false;
      }

      if (opts.currentProductOnly) {
        var scope = (logic.appliedTo && logic.appliedTo[0]) || '';
        if (scope === 'products') {
          var ids = Array.isArray(logic.products) ? logic.products.map(function (p) { return String(p.id); }) : [];
          if (ids.indexOf(opts.productId) === -1) return false;
        } else if (scope === 'collections') {
          var cids = Array.isArray(logic.collections) ? logic.collections.map(function (c) { return String(c.id); }) : [];
          var hit = cids.some(function (id) { return opts.productCollections.indexOf(id) !== -1; });
          if (!hit) return false;
        } else if (scope === 'conditions') {
          if (!opts.includeConditionFees) return false;
        }
      }

      return true;
    }

    function render(container, fees, base) {
      var wantHandle = container.dataset.marketHandle || '';
      if (wantHandle && wantHandle !== base.marketHandle) return;

      var opts = {
        marketId: base.marketId,
        marketHandle: base.marketHandle,
        productId: base.productId,
        productCollections: base.productCollections,
        currentProductOnly: container.dataset.currentProductOnly !== 'false',
        onlyMarketScoped: container.dataset.onlyMarketScoped === 'true',
        includeConditionFees: container.dataset.includeConditionFees === 'true'
      };

      var matched = fees.filter(function (fee) {
        if (!fee || !fee.id || !fee.logic) return false;
        return feeApplies(fee, opts);
      });
      if (!matched.length) return;

      container.innerHTML = '';

      var heading = container.dataset.heading || '';
      if (heading) {
        var h = document.createElement('p');
        h.className = 'associated-market-fees__heading';
        h.textContent = heading;
        container.appendChild(h);
      }

      var ul = document.createElement('ul');
      ul.className = 'associated-market-fees__list';
      matched.forEach(function (fee) {
        var li = document.createElement('li');
        li.className = 'associated-market-fees__item';

        var name = document.createElement('span');
        name.className = 'associated-market-fees__name';
        name.textContent = decodeEntities(fee.title);
        li.appendChild(name);

        var amount = document.createElement('span');
        amount.className = 'associated-market-fees__amount';
        amount.textContent = feeAmount(fee);
        li.appendChild(amount);

        if (fee.details) {
          var details = document.createElement('span');
          details.className = 'associated-market-fees__details';
          details.textContent = decodeEntities(fee.details);
          li.appendChild(details);
        }

        ul.appendChild(li);
      });
      container.appendChild(ul);
      container.hidden = false;
    }

    function init() {
      var containers = document.querySelectorAll('.associated-market-fees');
      if (!containers.length) return;

      var jsonEl = document.querySelector('magical-mandatory-fees script[type="application/json"]');
      if (!jsonEl) {
        console.warn('[associated-market-fees] Magical Fees app embed not found. Enable the app embed in your theme.');
        return;
      }

      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (err) {
        console.warn('[associated-market-fees] Could not parse Magical Fees app data.', err);
        return;
      }

      var market = data.market || {};
      var product = data.current_product || {};
      var base = {
        marketId: market.id != null ? String(market.id) : '',
        marketHandle: market.handle || '',
        productId: product.id != null ? String(product.id) : '',
        productCollections: Array.isArray(product.collections)
          ? product.collections.map(function (c) { return String(c.id); })
          : []
      };
      var fees = Array.isArray(data.fees_metaobjects) ? data.fees_metaobjects : [];

      containers.forEach(function (container) {
        render(container, fees, base);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
